export default __webpack_public_path__ + "static/media/wave-3.527d7f5e.png";